import React from 'react';
import PropTypes from 'prop-types';
import PlusIcon from '../themes/svg/plusIcon';
import NameEntryModal from './NameEntryModal';

const NewEstimateButton = (props) => {
  const {
    newDesignModalOpen,
    controlNewDesignModal,
    validate,
    addDesign,
    defaultName,
  } = props;
  const openModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    controlNewDesignModal({ newDesignModalOpen: true });
  };

  const closeModal = () => {
    controlNewDesignModal({ newDesignModalOpen: false });
  };
  return (
    <div className="addEstimate">
      <button id="addEstimate" className="addButton" onClick={openModal}>
        <PlusIcon />
      </button>
      <NameEntryModal
        modalIsOpen={newDesignModalOpen}
        validate={validate}
        action={addDesign}
        title="Add New Design"
        verb="Add Design"
        defaultName={defaultName}
        closeModal={closeModal}
      />
    </div>
  );
};
NewEstimateButton.defaultProps = {
  newDesignModalOpen: false,
};

NewEstimateButton.propTypes = {
  controlNewDesignModal: PropTypes.func.isRequired,
  addDesign: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  defaultName: PropTypes.string.isRequired,
  newDesignModalOpen: PropTypes.bool,
};

export default NewEstimateButton;
